/**
 * Bow Shock — clickable top-level mega-menu parents.
 *
 * Theme renders parents with children as <summary> (opens panel only).
 * We wrap the title in <a href>, so:
 *  - click title → navigate to parent collection/page
 *  - click caret / empty summary space → toggle panel
 *  - desktop hover → open panel (submenu stays discoverable)
 */
(function () {
  function stopToggleOnTitleClick(root) {
    root.querySelectorAll("header-menu > details > summary a.header__menu-item-link").forEach(function (link) {
      if (link.dataset.bowshockClickableMenu === "true") return;
      link.dataset.bowshockClickableMenu = "true";
      link.addEventListener("click", function (event) {
        // Let the browser follow href; don't also toggle <details>.
        event.stopPropagation();
      });
    });
  }

  function enableHoverOpen(root) {
    if (!window.matchMedia("(hover: hover) and (min-width: 990px)").matches) return;

    root.querySelectorAll("header-menu").forEach(function (menu) {
      if (menu.dataset.bowshockHoverMenu === "true") return;
      menu.dataset.bowshockHoverMenu = "true";

      var details = menu.querySelector("details");
      if (!details) return;
      var summary = details.querySelector("summary");
      var closeTimer;

      menu.addEventListener("mouseenter", function () {
        clearTimeout(closeTimer);
        details.setAttribute("open", "");
        if (summary) summary.setAttribute("aria-expanded", "true");
        if (menu.header) menu.header.preventHide = true;
        var header = document.querySelector(".header-wrapper");
        if (header) header.preventHide = true;
      });

      menu.addEventListener("mouseleave", function () {
        closeTimer = setTimeout(function () {
          details.removeAttribute("open");
          if (summary) summary.setAttribute("aria-expanded", "false");
          var header = document.querySelector(".header-wrapper");
          if (header) header.preventHide = false;
        }, 120);
      });
    });
  }

  function init(root) {
    var scope = root || document;
    stopToggleOnTitleClick(scope);
    enableHoverOpen(scope);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target || document);
  });
})();
